module.exports = __webpack_public_path__ + "img/pattern1.857d614.svg";